import React from "react";
import need1 from "/need/need_1.webp";
import need2 from "/need/need_2.webp";
import need3 from "/need/need_3.webp";
import need4 from "/need/need_4.webp";
import need5 from "/need/need_5.webp";

export const WeDo: React.FC = () => {
  const needs = [need1, need2, need3, need4, need5];

  const needTitles = [
    "Museum & Gallery exhibits",
    "Thematic space design",
    "Story-driven spatial zones",
    "Interactive urban installations",
    "Immersive Launch Arenas",
  ];

  return (
    <>
      <div className="w-full min-h-[220vh] relative flex flex-col mt-72 mb-32">
        <div className="w-full sticky top-0 h-screen flex flex-col justify-center items-center">
          <div className="w-full  lg:pt-16 md:pt-8 pt-4  -z-10 lg:text-5xl text-2xl text-center">
            You need, We do it!<span className="text-[#FB2C36]">.</span>
          </div>

          <div className="w-full h-fit relative  lg:px-24 md:px-16 px-8 pt-16 z-50">
            {needTitles.map((title, index) => (
              <div
                key={index}
                className="py-8 lg:text-6xl md:text-4xl font-nyght-serif-regular text-2xl content-center text-center"
              >
                {title}
              </div>
            ))}
          </div>
        </div>

        <div className="absolute w-full h-fit flex flex-col lg:px-24 md:px-16 px-8 mt-28">
          {needs.map((need, index) => (
            <div
              className={`w-full flex items-center ${index % 2 === 0 ? "justify-start" : "justify-end"} min-h-[40vh] h-fit `}
            >
              <div className={``}>
                <img
                  key={index}
                  src={need}
                  alt={`Need ${index + 1}`}
                  className="lg:w-fit w-[20vw] h-full object-cover"
                />
              </div>
            </div>
          ))}
        </div>
        {/* </div> */}
        {/* <div className="absolute"> */}
        {/* {needs.map((_, index) => (
            <div
              key={index}
              style={{
                position: "sticky",
                top: `${index * 120}px`,
              }}
              className="w-full min-h-[40vh]  lg:text-5xl text-2xl content-center text-center"
            >
              Need {index + 1}
            </div>
          ))} */}
        {/* </div> */}
      </div>
    </>
  );
};
